import React from 'react';

const PayrollHeader = ({ currentMonth, avgNetSalary }) => {
  return (
    <div className="bg-gradient-to-r from-indigo-600 to-purple-700 dark:from-indigo-800 dark:to-purple-900 px-6 py-5 rounded-2xl shadow-lg">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center">
        <div>
          <h1 className="text-2xl font-bold text-white">Payroll History</h1>
          <p className="text-indigo-200 dark:text-purple-200 mt-1">
            Review your monthly salary statements
          </p>
        </div>
        <div className="bg-white/20 backdrop-blur-sm rounded-full px-4 py-2 mt-4 md:mt-0">
          <p className="text-white text-sm">
            Current Month: {currentMonth} • Average Net: ${avgNetSalary}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PayrollHeader;
